// extracted by mini-css-extract-plugin
module.exports =  {"list":"ccfda6eb9f--list--GA3Gg","item":"ccfda6eb9f--item--N0m8K"};